import { emailRegex, isAliasedEmail, newPhoneRegex } from '@lib/util/regex';
import * as Yup from "yup"

const isValidVariantObject = (variant: any) => {
    return variant.id !== "" && variant.title !== "" && variant.price !== 0
}

const emailValidation = Yup.string()
    .matches(emailRegex, "Invalid email address")
    .test('no-alias', "Aliased email addresses (e.g., addresses with a '+' symbol) are not allowed. Please enter a valid email address.",
        value => value ? !isAliasedEmail(value) : true
    )

export const validationSchema = Yup.object().shape({
    variant: Yup.mixed().test(
        "isValidVariantObject",
        "Amount is required",
        isValidVariantObject
    ),

})

const validateEmail = (email: string) => {
  return emailRegex.test(email);
};

const validatePhoneNumber = (phone: string) => {
  return newPhoneRegex.test(phone);
};

export const validationRecipientSchema = Yup.object({
  recipients: Yup.array().of(
    Yup.object({
      metadata: Yup.object({
        sender_name: Yup.string()
          .required('Sender name is required'),
        sender_email: Yup.string()
          .required('Sender email is required')
          .test('isValidSenderEmail', 'Invalid sender email format', value => value ? validateEmail(value) : true),
        recipient_name: Yup.string()
          .required('Recipient name is required'),
        recipient_email: Yup.string()
          .required('Recipient email is required')
          .test('isValidRecipientEmail', 'Invalid recipient email format', value => value ? validateEmail(value) : true),
        recipient_email_confirm: Yup.string()
          .required('Recipient email confirm is required')
          .oneOf([Yup.ref('recipient_email')], 'Recipient email confirm must match')
          .test('isValidRecipientEmailConfirm', 'Invalid recipient email confirm format', value => value ? validateEmail(value) : true),
        recipient_phone_number: Yup.string()
          .required('Recipient phone number is required')
          .test('isValidPhone', 'Invalid phone number format', value => value ? validatePhoneNumber(value) : true),
        recipient_phone_number_confirm: Yup.string()
          .required('Recipient phone number confirm is required')
          .oneOf([Yup.ref('recipient_phone_number')], 'Recipient phone confirm number must match')
          .test('isValidPhone', 'Invalid phone number format', value => value ? validatePhoneNumber(value) : true),
      })
    })
  ),
});
